
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
import img110 from "../assets/images/SCVL.JPEG";
import imgImage0011 from "../assets/images/CKHC.png";

export default function CharitiesPage() {
  const charities = [
    {
      name: 'Coastal Kids Home Care',
      url: 'https://www.coastalkidshomecare.org',
      image: imgImage0011,
      alt: 'Coastal Kids Home Care 20th Anniversary Logo',
      description: 'Supporting children and families with specialized home care services'
    },
    {
      name: 'Sand City Volleyball Club',
      url: 'https://www.sandcityvolleyball.org',
      image: img110,
      alt: 'Sand City Volleyball Club Logo',
      description: 'Empowering youth through sports and teamwork'
    }
  ];

  return (
    <div className="bg-gradient-to-br from-gray-50 via-white to-gray-50 py-16 md:py-24 min-h-screen">
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto mb-16"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
            className="inline-block mb-6"
          >
            <div className="p-4 bg-gradient-to-br from-[#de0016] to-[#ff1a2f] rounded-full">
              <Heart className="w-12 h-12 md:w-16 md:h-16 text-white fill-white" />
            </div>
          </motion.div>

          <h1 className="font-['Josefin_Sans'] font-bold text-[#de0016] text-3xl md:text-5xl lg:text-6xl mb-6 leading-tight">
            We are proud to support our charities
          </h1>

          <p className="font-['Josefin_Sans'] text-gray-600 text-xl md:text-2xl lg:text-3xl leading-relaxed">
            Broadway Bingo Players make it possible for these charities to achieve their missions
          </p>
        </motion.div>

        {/* Charities Grid */}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto">
          {charities.map((charity, index) => (
            <motion.div
              key={charity.name}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 + index * 0.2 }}
              whileHover={{ y: -8 }}
              className="group"
            >
              <a
                href={charity.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visit ${charity.name} website (opens in a new tab)`}
                className="block h-full rounded-3xl focus:outline-none focus-visible:ring-2 focus-visible:ring-[#de0016] focus-visible:ring-offset-4"
              >
                <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all border border-gray-100 h-full">
                  {/* Card Header */}
                  <div className="text-center mb-6">
                    <h2 className="font-['Josefin_Sans'] font-bold text-gray-900 text-2xl md:text-3xl mb-3">
                      {charity.name}
                    </h2>
                    <p className="font-['Josefin_Sans'] text-gray-600 text-lg">
                      {charity.description}
                    </p>
                  </div>

                  {/* Logo Container */}
                  <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-50 to-white p-6">
                    {/* Decorative gradient overlay */}
                    <div className="absolute inset-0 bg-gradient-to-br from-[#de0016]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />

                    <motion.div
                      className="relative w-full aspect-square max-w-[417px] mx-auto"
                      whileHover={{ scale: 1.05 }}
                      transition={{ type: "spring", stiffness: 300 }}
                    >
                      <img
                        alt={charity.alt}
                        className="w-full h-full object-contain drop-shadow-lg"
                        src={charity.image}
                      />
                    </motion.div>
                  </div>

                  {/* Decorative bottom accent */}
                  <div className="mt-6 flex justify-center">
                    <div className="h-1 w-24 bg-gradient-to-r from-transparent via-[#de0016] to-transparent rounded-full opacity-50 group-hover:opacity-100 group-hover:w-32 transition-all" />
                  </div>

                  <p className="mt-4 text-center font-['Josefin_Sans'] text-[#de0016] font-semibold">
                    Visit Website →
                  </p>
                </div>
              </a>
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 1 }}
          className="text-center mt-16"
        >
        </motion.div>
      </div>
    </div>
  );
}
